module.exports = __webpack_public_path__ + "img/TV-icon.5f0372b2.png";